import { toRefs, computed } from 'vue';
import { useTheme } from '../../compositions/component-lib.esm7.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm3.js';

//
const variantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body: 'p'
};

/**
 * A component for consistently rendering any textual element
 * on the page
 */
var script = {
  name: 'VText',
  props: {
    /** Set the text-align on the text element. */
    align: {
      type: String,
      default: 'inherit'
    },
    color: String,
    /** Specify which HTML element or React component is used for the root element */
    component: String,
    /** Control how this Text renders */
    variant: {
      type: String,
      default: 'body'
    },
    /** Add a bottom margin to the text */
    gutterBottom: Boolean,
    /** Prevent the text from wrapping to the next line */
    noWrap: Boolean
  },
  setup(props) {
    const {
      align,
      color,
      gutterBottom,
      variant,
      noWrap
    } = toRefs(props);
    const theme = useTheme();
    const themeColor = computed(() => {
      return color.value ? getThemeColor(color.value, theme.value) : theme.value.colors.onBg;
    });
    const styles = computed(() => {
      return {
        '--text-align': align.value,
        '--text-color': themeColor.value,
        '--margin-bottom': gutterBottom.value ? '1em' : '0'
      };
    });
    const classes = computed(() => {
      return {
        [`v-text--${variant.value}`]: true,
        'v-text--nowrap': noWrap.value
      };
    });
    return {
      styles,
      classes,
      variantMapping
    };
  }
};
export { script as default };